import React from 'react';
import styles from './theme-item.less';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { IRightMenuManager } from '@src/slide/application/service/right-menu-manager/core/right-menu-manager.interface';
import { IThemeColorManager } from '@src/slide/application/service/theme-color-manager/index.interface';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export interface IPreviewThemeItem {
    key: string;
    title: string;
    colorList: Array<IThemeColor>;
}

export interface IMenuProps {
    top: number;
    left: number;
    minWidth: number;
    subMinWidth: number;
    zIndex?: number;
    onSubMenuVisibleChange(menuData);
}


export interface IThemeColor {
    val: STSchemeColorVal,
    color: string,
}

interface IThemeItemProps {
    rightMenuManager?: IDynamicService<IRightMenuManager>;
    themeColorManager?: IThemeColorManager;
    menuManager?: IMenuManager;
    themeItem: IThemeSelectItem;
    selected: boolean;
    canEdit: boolean;
    onClick(): void;
}

interface IColorItemProps {
    color: string;
}

export class ThemeItem extends React.Component<IThemeItemProps, any> {
    private rightMenuManager;

    constructor(props: IThemeItemProps) {
        super(props);
        this.props.rightMenuManager?.promise().then((module) => {
            this.rightMenuManager = module;
        });
    }

    render() {
        const { selected, themeItem } = this.props;
        const { title, colorSchema, isVip, id, subTitle } = themeItem;
        const { themeColorManager } = this.props;
        let renderTitle = title;
        if (subTitle) {
            renderTitle += ` ${subTitle}`;
        }
        return <div
            onClick={this.props.onClick}
            className={styles['theme-item-wrapper']}>
            <div className={styles['theme-item-title']}>
                <div
                    style={{
                        width: 'max-content',
                    }}
                >
                    { renderTitle }
                </div>
                {/* { isVip */}
                {/*     && <img */}
                {/*         src={VIP_ICON} */}
                {/*         style={{ */}
                {/*             display: 'block', */}
                {/*             width: 12, */}
                {/*             height: 12, */}
                {/*             marginLeft: 4, */}
                {/*         }} */}
                {/*     /> */}
                {/* } */}
            </div>
            <Tooltip
                title={renderTitle}
                trigger={'hover'}
                placement={'bottom'}
            >
                <div
                    onContextMenu={(e) => {
                        if (this.props.canEdit) {
                            themeColorManager?.setCurrentEditKey(id);
                            this.showRightMenu(e);
                        }
                    }}
                    className={styles['theme-item-color-group']}>
                    {
                        !selected && <div className={styles['theme-item-color-hover']} />
                    }
                    <ColorItem color={colorSchema.dk2.color} key={colorSchema.dk2.val + colorSchema.dk2.color} />
                    <ColorItem color={colorSchema.lt2.color} key={colorSchema.lt2.val + colorSchema.lt2.color} />
                    <ColorItem
                        color={colorSchema.accent1.color} key={colorSchema.accent1.val + colorSchema.accent1.color} />
                    <ColorItem
                        color={colorSchema.accent2.color} key={colorSchema.accent2.val + colorSchema.accent2.color} />
                    <ColorItem
                        color={colorSchema.accent3.color} key={colorSchema.accent3.val + colorSchema.accent3.color} />
                    <ColorItem
                        color={colorSchema.accent4.color} key={colorSchema.accent4.val + colorSchema.accent4.color} />
                    <ColorItem
                        color={colorSchema.accent5.color} key={colorSchema.accent5.val + colorSchema.accent5.color} />
                    <ColorItem
                        color={colorSchema.accent6.color} key={colorSchema.accent6.val + colorSchema.accent6.color} />
                    {
                        selected && <div className={styles['theme-item-color-selected']} />
                    }
                </div>
            </Tooltip>
        </div>;
    }

    private showRightMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const { themeColorManager, menuManager } = this.props || {};

        if (!menuManager) return;
        const e = event.nativeEvent as MouseEvent;

        const disableIds = [];
        if (themeColorManager) {
            const menuData = menuManager.getRightMenuFromTheme(themeColorManager.currentThemeModel!);
            menuManager.hideAllMenu();
            this.handleShowRightMenu(menuData.type, menuData.items, disableIds, {
                top: e.clientY,
                left: e.clientX + 8,
                minWidth: 200,
                subMinWidth: 200,
                zIndex: 10005,
                onSubMenuVisibleChange: () => {},
            }, (menuType, itemID, object) => {
                menuData.callback(menuType, itemID, {
                    object,
                });
            });
        }
    };

    private handleShowRightMenu = (
        type: string,
        items: Array<any>, // 整理menu时定义下各种menuItems
        disabledIds: Array<string>,
        props: IMenuProps,
        callback,
    ) => {
        if (this.rightMenuManager) {
            this.rightMenuManager.showMenu(type, items, disabledIds, props, (...args) => {
                this.rightMenuManager.hideMenu(type);
                callback(...args);
            });
        }
    };
}

class CustomColorDialog extends React.Component<IColorItemProps, any> {
    render() {
        return <div
            className={styles['color-item-wrapper']}
            style={{
                background: `#${this.props.color}`,
            }}
        />;
    }
}

class ColorItem extends React.Component<IColorItemProps, any> {
    render() {
        return <div
            className={styles['color-item-wrapper']}
            style={{
                background: `#${this.props.color}`,
            }}
        />;
    }
}
